<script setup lang="ts">
// Údržba strip only on the login/registration screens — the demo funnel and the
// public legal pages keep working during maintenance and must not scare visitors.
const route = useRoute()
const showMaintenance = computed(() => route.path.startsWith('/auth'))
</script>

<template>
  <div>
    <MaintenanceBanner v-if="showMaintenance" />
    <slot />
  </div>
</template>
